import {InjectionToken} from "@angular/core";

export interface MvsFormUseCaseToken {
    useCase: string;
}

export const MVS_FORM_USE_CASE_TOKEN = new InjectionToken<MvsFormUseCaseToken>('MvsFormUseCaseToken');
